import {
  PLACE_ORDER_SUCCESS,
  GET_ALL_ORDER_SUCCESS,
  GET_ORDER_SUCCESS,
  GET_AMAZON_ORDERS,
  GET_DEVICE_ACTIVATE_REQUESTS,
  GET_SIM_ACTIVATE_REQUESTS,
  GET_AUTO_RENEWALS,
  GET_AUTO_RENEWAL_ORDERS,
} from "../actions/types";
const initialState = {
  order: {},
  page: 0,
  total: 0,
  orderslist: [],
  orderDetail: {},
  simActivateRequests: [],
  deviceActivateRequests: [],
  autoRenewals: [],
  autoRenewalOrders: [],
}

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case PLACE_ORDER_SUCCESS:
      console.log('reducer', action)
      return {
        ...state,
        order: action.order,
      }
    case GET_AMAZON_ORDERS:
      return {
        ...state,
        amazonOrders: action.amazonOrders,
      }
    case GET_DEVICE_ACTIVATE_REQUESTS:
      return {
        ...state,
        deviceActivateRequests: action.deviceActivateRequests,
      }
    case GET_SIM_ACTIVATE_REQUESTS:
      return {
        ...state,
        simActivateRequests: action.simActivateRequests,
      }
    case GET_ALL_ORDER_SUCCESS:
      return {
        ...state,
        page: action.page,
        total: action.total,
        orderslist: action.orderslist,
      }
    case GET_ORDER_SUCCESS:
      return {
        ...state,
        orderDetail: action.orderDetail,
      }
    case GET_AUTO_RENEWALS:
      return {
        ...state,
        autoRenewals: action.autoRenewals,
      }
    case GET_AUTO_RENEWAL_ORDERS:
      return {
        ...state,
        autoRenewalOrders: action.autoRenewalOrders,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/ducks/reducers/order.js